var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxfenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "final_svg",
    viewBox: "483.4480895996094 489.5039978027344 110.25003051757812 98.99398803710938",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "png_group",
    transform: "translate(483.448098, 489.504) scale(0.35)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    height: 98.9975,
    width: 110.25,
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_index_0",
    fill: "rgba(244, 188, 6, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.9,133.26H0V0h315v97.51h-31.96V31.96H31.96v69.34h80.94V133.26z M315,149.59H202.1v31.96h80.94v69.34H31.96v-65.55H0 v97.5h315V149.59z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxfenIcon);
export default __webpack_public_path__ + "static/media/taxfen-icon.29ea1a69e792c9da549381377655feb4.svg";
export { ForwardRef as ReactComponent };